import * as React from 'react';
import {StyleProp, Platform, View, ViewStyle, StyleSheet} from 'react-native';
import {Form as RFForm} from 'redux-form';

interface IStateProps {
  style?: StyleProp<ViewStyle>;
  onSubmit: (e?: any) => void;
  children?: React.ReactNode;
}

export const Form: React.FC<IStateProps> = ({style, onSubmit, children}) => {
  return Platform.OS === 'web' ? (
    <RFForm
      style={
        StyleSheet.flatten([
          {
            display: 'flex',
            flexDirection: 'column',
          },
          style,
        ]) as any
      }
      onSubmit={onSubmit}>
      {children}
      <input type='submit' style={{position: 'absolute', left: -9999, top: -9999, opacity: 0}} />
    </RFForm>
  ) : (
    <View style={style}>{children}</View>
  );
};
